import { createContext, useContext, useEffect, useState } from 'react'
import { useAuth } from './AuthContext'
import { useCronograma } from './CronogramaContext'
import { useArticulos } from './ArticulosContext'

const NotificacionesContext = createContext()

export const useNotificaciones = () => useContext(NotificacionesContext)

export const NotificacionesProvider = ({
  children,
  notificationSection = 'notificaciones',
}) => {
  const { user } = useAuth()
  const { cronograma } = useCronograma()
  const { articulos } = useArticulos()

  const [notificaciones, setNotificaciones] = useState(
    JSON.parse(localStorage.getItem(notificationSection)) || {},
  )
  // const [notificacionesLoading, setNotificacionesLoading] = useState(false)

  useEffect(() => {
    if (cronograma) {
      let newsNotifications = {}
      if (
        user?.rol?.id_rol !== '3' &&
        user?.rol?.id_rol !== '4' &&
        user?.rol?.id_rol !== '5'
      ) {
        if (articulos.puedePedir && !articulos.puedePedir.puedePedir) {
          newsNotifications = {
            ...newsNotifications,
            habilitacionCronograma: {
              text: `No se pueden realizar pedidos al proveedor. Motivos: ${articulos.puedePedir.motivo} -.`,
              notificationName: 'pedidosProveedor',
            },
          }
        }

        if (user?.rol?.id_rol === '2') {
          if (cronograma?.habilitado) {
            newsNotifications = {
              ...newsNotifications,
              habilitacionCronograma: {
                text: 'El conograma actual ya está habilitado para compras.',
                notificationName: 'habilitacionCronograma',
              },
            }
          } else {
            newsNotifications = {
              ...newsNotifications,
              habilitacionCronograma: {
                text: 'Tu coordinadora aún no habilitó el cronograma.',
                notificationName: 'habilitacionCronograma',
              },
            }
          }
        }
      }
      if (user?.rol?.id_rol === '5') {
        newsNotifications = {
          ...newsNotifications,
          modificacionesPedidos: {
            text: 'Para solicitar modificaciones de requerimiento, producto o precio comunicate con operaciones@faccargentina.coop',
            notificationName: 'modificacionesPedidos',
          },
        }
      }
      localStorage.setItem('notificaciones', JSON.stringify(newsNotifications))
      setNotificaciones(newsNotifications)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cronograma, user])

  const contextValues = {
    notificaciones,
    setNotificaciones,
  }

  return (
    <NotificacionesContext.Provider value={contextValues}>
      {children}
    </NotificacionesContext.Provider>
  )
}
